import type { UseFormProps } from "react-hook-form";

// NOTE: House-standard validation triggers for all forms using react-hook-form.
// onTouched keeps the form clean until the user interacts with a field; validation
// is initially triggered on the first blur event, then on every change event
// afterward so corrections clear immediately.
export const FORM_VALIDATION_OPTIONS = {
  mode: "onTouched",
  reValidateMode: "onChange",
} as const satisfies Pick<UseFormProps, "mode" | "reValidateMode">;
